import React from 'react';

import '../../form.css';
import { Form, Row, Col, Input, Select, Button, DatePicker, Cascader, } from 'antd';

import {
    SearchOutlined,
    ReloadOutlined,
} from '@ant-design/icons';

const { RangePicker } = DatePicker;
const { Option } = Select;

const options = [
    {
        value: 'zhejiang',
        label: 'Zhejiang',
        children: [
            {
                value: 'hangzhou',
                label: 'Hangzhou',
                children: [
                    {
                        value: 'xihu',
                        label: 'West Lake',
                    },
                ],
            },
        ],
    },
    {
        value: 'jiangsu',
        label: 'Jiangsu',
        children: [
            {
                value: 'nanjing',
                label: 'Nanjing',
                children: [
                    {
                        value: 'zhonghuamen',
                        label: 'Zhong Hua Men',
                    },
                ],
            },
        ],
    },
];

class ExtraSearchForm extends React.Component {

    render() {
        const dateFormat = 'YYYY/MM/DD';
        const onFinishFailed = (errorInfo: any) => {
            console.log('Failed:', errorInfo);
        };
        const onReload = () => {
            window.location.reload();
        };
        return (

            <Form
                layout='inline'
            >
                <Row gutter={[18, 18]}>
                    <Col>
                        <Form.Item
                            name="name"
                        >
                            <Input allowClear placeholder="关键词" />
                        </Form.Item>
                    </Col>
                    <Col>
                        <Form.Item
                            name="departureCity"
                            label="出发城市"
                        >
                            <Cascader options={options} placeholder="" />
                        </Form.Item>
                    </Col>

                    <Col>
                        <Form.Item
                            name="currentCity"
                            label="资源所用城市"
                        >
                            <Cascader options={options} placeholder="" />
                        </Form.Item>
                    </Col>

                    <Col>
                        <Form.Item
                            name="from"
                            label="资源类别"
                        >
                            <Select defaultValue="0">
                                <option value="0">全部</option>
                                <option value="1">包车</option>
                                <option value="2">租车</option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col>
                        <Button type="primary" htmlType="submit">
                            <SearchOutlined />
									搜索
								</Button>
                    </Col>
                    <Col>
                        <Button
                            type="default"
                            onClick={onReload}
                        >
                            <ReloadOutlined />
									重置
								</Button>
                    </Col>
                </Row>
            </Form>

        )
    }
}

export default ExtraSearchForm;